var moduleMap = {
	"./Pages": () => {
		return Promise.all([__webpack_require__.e(6751), __webpack_require__.e(5922), __webpack_require__.e(4511), __webpack_require__.e(597), __webpack_require__.e(6606), __webpack_require__.e(9214), __webpack_require__.e(1181), __webpack_require__.e(2508), __webpack_require__.e(3642), __webpack_require__.e(1496), __webpack_require__.e(2427), __webpack_require__.e(3407), __webpack_require__.e(1442), __webpack_require__.e(9356), __webpack_require__.e(9251), __webpack_require__.e(5237), __webpack_require__.e(1081), __webpack_require__.e(9661), __webpack_require__.e(1647), __webpack_require__.e(3297), __webpack_require__.e(6638), __webpack_require__.e(8148), __webpack_require__.e(2204), __webpack_require__.e(9954), __webpack_require__.e(7859), __webpack_require__.e(8435), __webpack_require__.e(646), __webpack_require__.e(5774), __webpack_require__.e(5406), __webpack_require__.e(4439), __webpack_require__.e(101), __webpack_require__.e(8597), __webpack_require__.e(7184), __webpack_require__.e(6818), __webpack_require__.e(9457), __webpack_require__.e(1750), __webpack_require__.e(4480)]).then(() => (() => ((__webpack_require__(944280)))));
	},
	"./Reducers": () => {
		return Promise.all([__webpack_require__.e(5237), __webpack_require__.e(1081), __webpack_require__.e(9661), __webpack_require__.e(8435), __webpack_require__.e(646), __webpack_require__.e(7184), __webpack_require__.e(9457), __webpack_require__.e(7181), __webpack_require__.e(6897)]).then(() => (() => ((__webpack_require__(466897)))));
	},
	"./Sagas": () => {
		return Promise.all([__webpack_require__.e(6797), __webpack_require__.e(1081), __webpack_require__.e(9954), __webpack_require__.e(646), __webpack_require__.e(5774), __webpack_require__.e(4439), __webpack_require__.e(7184), __webpack_require__.e(1750), __webpack_require__.e(9747), __webpack_require__.e(272)]).then(() => (() => ((__webpack_require__(209747)))));
	},
	"./Actions": () => {
		return __webpack_require__.e(1687).then(() => (() => ((__webpack_require__(321687)))));
	},
	"./Types": () => {
		return __webpack_require__.e(1713).then(() => (() => ((__webpack_require__(491713)))));
	},
	"./Translations": () => {
		return Promise.all([__webpack_require__.e(101), __webpack_require__.e(653)]).then(() => (() => ((__webpack_require__(180653)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});